import type { ApplicationStatus } from '@core/types';

const hiddenKey = (orgId: string, userKeycloakId: string) =>
  `ggj_b2b_kanban_hidden_cols_${orgId}_${userKeycloakId}`;
const fieldsKey = (orgId: string, userKeycloakId: string) =>
  `ggj_b2b_kanban_card_fields_${orgId}_${userKeycloakId}`;

export type KanbanCardFieldPrefs = {
  showRating: boolean;
  showAtsRing: boolean;
  showJobClient: boolean;
  showMetaRow: boolean;
  showResumeAssignedRow: boolean;
  showSubmitted: boolean;
};

export const DEFAULT_KANBAN_CARD_FIELDS: KanbanCardFieldPrefs = {
  showRating: true,
  showAtsRing: true,
  showJobClient: true,
  showMetaRow: true,
  showResumeAssignedRow: true,
  showSubmitted: true,
};

/** Stages often treated as “backlog” before active recruiting — user can refine in Configure board. */
export const KANBAN_BACKLOG_PRESET: ApplicationStatus[] = ['submitted', 'viewed_by_client', 'on_hold'];

function parseHidden(raw: string | null): Set<ApplicationStatus> {
  if (!raw) return new Set();
  try {
    const a = JSON.parse(raw) as unknown;
    if (!Array.isArray(a)) return new Set();
    const out = new Set<ApplicationStatus>();
    for (const x of a) {
      if (typeof x === 'string') out.add(x as ApplicationStatus);
    }
    return out;
  } catch {
    return new Set();
  }
}

export function loadKanbanHiddenStatuses(orgId: string, userKeycloakId: string): Set<ApplicationStatus> {
  if (typeof window === 'undefined') return new Set();
  try {
    return parseHidden(localStorage.getItem(hiddenKey(orgId, userKeycloakId)));
  } catch {
    return new Set();
  }
}

export function saveKanbanHiddenStatuses(
  orgId: string,
  userKeycloakId: string,
  hidden: Set<ApplicationStatus>
): void {
  try {
    localStorage.setItem(hiddenKey(orgId, userKeycloakId), JSON.stringify([...hidden]));
  } catch {
    /* ignore */
  }
}

export function loadKanbanCardFields(orgId: string, userKeycloakId: string): KanbanCardFieldPrefs {
  if (typeof window === 'undefined') return { ...DEFAULT_KANBAN_CARD_FIELDS };
  try {
    const raw = localStorage.getItem(fieldsKey(orgId, userKeycloakId));
    if (!raw) return { ...DEFAULT_KANBAN_CARD_FIELDS };
    const o = JSON.parse(raw) as Partial<KanbanCardFieldPrefs>;
    return { ...DEFAULT_KANBAN_CARD_FIELDS, ...o };
  } catch {
    return { ...DEFAULT_KANBAN_CARD_FIELDS };
  }
}

export function saveKanbanCardFields(
  orgId: string,
  userKeycloakId: string,
  prefs: KanbanCardFieldPrefs
): void {
  try {
    localStorage.setItem(fieldsKey(orgId, userKeycloakId), JSON.stringify(prefs));
  } catch {
    /* ignore */
  }
}
